import { Suspense, useMemo, useState } from 'react'
import BookPackage from './BookPackage'
import BookPackageLoading from './BookPackageLoading'
import BookPackageFooter from './BookPackageFooter'
import { MODALS, useModal } from '../../../context/ModalProvider'
import EditBookPackageModal from './EditBookPackageModal'
import CornerConfirmModal from '../../../components/ui/CornerConfirmModal'
import BookPackageDecentralizeModal from './BookPackageDecentralizeModal'
import useGetBookCollection from '../book-list/hooks/useGetBookCollection'
import { useParseQuery } from '../../../hooks/useNav'
import useDeleteBookPackageByUuid from './hooks/useDeleteBookPackageByUuid'

function BookPackageContent() {
  const { queryParams } = useParseQuery()
  const { state, handleCloseModal } = useModal()
  const { data: { collections = [] } = {} } = useGetBookCollection()
  const { deleteBookPackageByUuidMutation } = useDeleteBookPackageByUuid()
  const [currentBookPackage, setCurrentBookPackage] = useState(null)
  const filteredCollection = useMemo(() => {
    const selectedOption = queryParams?.option
    // sort is mutable
    switch (selectedOption) {
      case '1':
        return [...collections].sort((a, b) => a.name.localeCompare(b.name)) // Sort by name in ascending order (A-Z)
      case '2':
        return [...collections].sort((a, b) => a.createdAt - b.createdAt) // Sort by createdAt in ascending order (oldest first)
      case '3':
        return [...collections].sort((a, b) => b.createdAt - a.createdAt) // Sort by createdAt in descending order (newest first)
      case '4':
        return [...collections].sort((a, b) => b.bookCount - a.bookCount) // Sort by bookCount in descending order (largest first)
      default:
        return [...collections]
    }
  }, [queryParams, collections])
  return (
    <>
      <div className="grid grid-cols-1 gap-x-6 gap-y-0 lg:grid-cols-2">
        {filteredCollection.map((bookPackage, index) => (
          <BookPackage
            key={bookPackage.uuid}
            uuid={bookPackage.uuid}
            name={bookPackage.name}
            description={bookPackage.description}
            userGroupCount={bookPackage.userGroupCount}
            bookCount={bookPackage.bookCount}
            index={index + 14}
            setCurrentBookPackage={setCurrentBookPackage}
          />
        ))}
      </div>
      <BookPackageFooter />
      {state === MODALS.EDIT_BOOK_PACKAGE &&
        currentBookPackage &&
        currentBookPackage.uuid && (
          <EditBookPackageModal
            uuid={currentBookPackage.uuid}
            name={currentBookPackage.name}
          />
        )}
      {state === MODALS.PERMISSION_BOOK_PACKAGE &&
        currentBookPackage &&
        currentBookPackage.uuid && (
          <BookPackageDecentralizeModal 
            bookPackageName={currentBookPackage.name} 
            uuid={currentBookPackage.uuid}
          />
        )}
      {state === MODALS.DELETE_BOOK_PACKAGE &&
        currentBookPackage &&
        currentBookPackage.uuid && (
          <CornerConfirmModal
            onSubmit={async () => {
              await deleteBookPackageByUuidMutation.mutate(
                currentBookPackage.uuid
              )
              handleCloseModal()
            }}
            title="Xác nhận xóa gói sách?"
            content={
              <div className="space-x-4">
                <p className="text-center">Thao tác này không thể hoàn tác! </p>
                <p className="text-center">
                  (Tất cả sách trong gói sách sẽ quay về gói sách mặc định)
                </p>
              </div>
            }
            onClose={() => {
              handleCloseModal()
            }}
            isLoading={deleteBookPackageByUuidMutation.isPending}
          />
        )}
    </>
  )
}

// Main component with Suspense
export default function BookPackageList() {
  return (
    <Suspense fallback={<BookPackageLoading />}>
      <BookPackageContent />
    </Suspense>
  )
}
